type LibraryTrack = { sourceType: string; metadata?: Record<string, unknown> };
const sources = new Set(['all', 'local', 'webdav', 'online', 'wy', 'tx']);
export const normalizeLibrarySource = (value: unknown) => typeof value === 'string' && sources.has(value) ? value : 'all';
export function matchesLibrarySource(track: LibraryTrack, value: unknown) {
  const source = normalizeLibrarySource(value);
  return source === 'all' || track.sourceType === source || track.sourceType === 'online' &&
    (track.metadata?.platform === source || source === 'tx' && track.metadata?.platform === 'qq');
}
